import classNames from 'classnames';
import { IconProgressActivity } from '../icons';
interface Props {
  className?: string;
}
const SpinnerLoading = ({
  className
}: Props) => {
  return <IconProgressActivity className={classNames('h-6 w-6 animate-spin', className)} data-sentry-element="IconProgressActivity" data-sentry-component="SpinnerLoading" data-sentry-source-file="spinner-loading.tsx" />;
};
export default SpinnerLoading;